interface SelectFieldProps {
  label: string;
  name?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: { value: string; label: string }[];
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options,
  required,
  placeholder,
  disabled = false,
}: SelectFieldProps) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <select
        name={name}
        value={value ?? ""}
        disabled={disabled}
        onChange={onChange}
        required={required}
        className={`w-full px-4 py-2.5 text-sm border border-gray-300 rounded-xl
          focus:outline-none focus:ring-2 focus:ring-[#2462b2]/20
          focus:border-[#2462b2] transition-all hover:border-[#2462b2]/50
          ${disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : "bg-white"}`}
      >

        {placeholder && (
          <option value="" disabled hidden={!!value}>
            {placeholder}
          </option>
        )}

        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;
